const validateAddress = (value) => {
  let errors;

  if (!value) {
    errors = "L'indirizzo è obbligatorio";
  } else {
   
    const validPrefixes = [
      "via", "v.","v",
      "viale", "v.le", "vl.",
      "piazza", "p.zza", "p.za",
      "corso", "c.so",
      "largo", "l.go",
      "piazzale", "p.le","pzl",
      "vicolo", "v.lo", "v.co",
      "strada", "s.da","str","ss","sp", "s.s.","s.p.",
      "stradale", "str.le",
      "rotonda", "rot.",
      "galleria", "g.le",
      "lungomare", "l.mare","lma",
      "lungolago", "l.lago",
      "lungotevere", "lgt.",
      "lungarno", "l.no",
      "salita", "sal.","sal",
      "discesa", "dis.","dis",
      "contrada", "c.da","con",
      "borgo", "b.go",
      "località", "loc.","loc",
      "traversa", "trav.", "trv",
      "passaggio", "pass.",
      "rione", "r.ne",
      "frazione", "fraz.","frz","frz.",
      "isola", "is.","is",
      "colle", "c.le",
      "costa", "c.ta",
      "circonvallazione", "circ.ne",
      "campo", "c.po",
      "calata", "c.ta",
      "alzaia", "alz.","alz",
      "parco", "p.co",
      "giardino", "g.no",
      "porto", "p.to",
      "molo", "m.lo"];


    const hasValidPrefix = validPrefixes.some((prefix) => 
      value.toLowerCase().startsWith(prefix)
    );

   
    const hasCivicNumber = /\b(\d{1,5}|snc?|s\.n\.c\.)\b/i.test(value);


    
    const hasCapAndCity = /\d{5}/.test(value) && /[A-Za-z\s]{2,}/.test(value);

    if (!hasValidPrefix) {
      errors = "L'indirizzo deve iniziare con un prefisso (es. Via, Piazza)";
    } else if (!hasCivicNumber) {
      errors = "L'indirizzo deve contenere un numero civico o snc";
    } else if (!hasCapAndCity) {
      errors = "Aggiungi un CAP e una città per completare l'indirizzo";
    }
  }

  return errors;
};


export default {validateAddress}
